import React, { useEffect, useState } from 'react';
import { Box, Image, Text, Container, Button, Grid } from '@chakra-ui/react';
import { default as Grow } from '../Assets/SVGs/grow.svg';
import { default as Support } from '../Assets/SVGs/support.svg';
import { default as Learn } from '../Assets/SVGs/learn.svg';
import '../Extra.scss';






function Area1(){
    return(
        <div>
            <Box mt="30px" >
                <Text fontSize="1rem" fontWeight="600" lineHeight="1.7" color="#4f8df7">
                    LET'S HANGOUT
                </Text>
                <Text fontSize={["2rem", "2rem", "2rem", "3.125rem"]} mt="20px" fontWeight="800" w={["100%", "100%", "100%", "60%"]}>
                    Use technology to get into real-life with real people.
                </Text>
                <Text fontWeight="600" my="auto" fontSize="20px" mt="20px" w={["100%", "100%", "100%", "60%"]}>
                    Join people in your community. Attend or host hangouts to learn new skills, grow your network, and make meaningful social connections in-person or online.
                </Text>

            </Box>
        </div>
    )
}

function Area2(){
    return(
        <div>
        <Box mt="100px" >

            <Grid templateColumns={["repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(3, 1fr)"]} gap={10} my={5}>

            <Box w="100%" mt="50px">
                    <Box mb={7}>
                    <img src={Grow} style={{margin: "auto", height: "150px", width: "100%"}} />
                    </Box>
                    <Text textAlign="center"  fontSize="1.5rem" fontWeight="800">
                        Grow
                    </Text>
                    <Text textAlign="center"  mt="10px" >
                        Build a network of new people through the things you love to do.
                    </Text>
                </Box>
                <Box w="100%" mt="50px" >
                    <Box mb={7}>
                    <img src={Support} style={{margin: "auto", height: "150px", width: "100%"}}  />
                    </Box>
                    <Text textAlign="center"  fontSize="1.5rem" fontWeight="800">
                        Support
                    </Text>
                    <Text textAlign="center"  mt="10px" >
                        Give back to your community by supporting local hosts and their crafts.
                    </Text>
                </Box>
                <Box w="100%" mt="50px" >
                    <Box mb={7}>
                    <img src={Learn} style={{margin: "auto", height: "150px", width: "66%"}}  />
                    </Box>
                    <Text textAlign="center"  fontSize="1.5rem" fontWeight="800">
                        Learn
                    </Text>
                    <Text textAlign="center"  mt="10px" >
                        Lead by example and attend other hangouts. Support and learn from other hosts that love what they do.
                    </Text>
                </Box>
            </Grid>

        </Box>
    </div>
    )
}





function Area3(){


    const images = [
        {url: `https://do1pg20gb8r9m.cloudfront.net/Interests/interest_1_.jpg`, name: 'Drama'}, 
        {url: `https://do1pg20gb8r9m.cloudfront.net/Interests/interest_2_.jpg`, name: 'Dancing'}, 
        {url: `https://do1pg20gb8r9m.cloudfront.net/Interests/interest_3_.jpg`, name: 'Music'},
        {url: `https://do1pg20gb8r9m.cloudfront.net/Interests/interest_4_.jpg`, name: 'Drawing'}, 
        {url: `https://do1pg20gb8r9m.cloudfront.net/Interests/interest_5_.jpg`, name: 'Painting'}, 
        {url: `https://do1pg20gb8r9m.cloudfront.net/Interests/interest_6_.jpg`, name: 'Sculpting'},
        {url: `https://do1pg20gb8r9m.cloudfront.net/Interests/interest_7_.jpg`, name: 'Photography'}, 
        {url: `https://do1pg20gb8r9m.cloudfront.net/Interests/interest_1_.jpg`, name: 'Drama'}, 
        {url: `https://do1pg20gb8r9m.cloudfront.net/Interests/interest_2_.jpg`, name: 'Dancing'}, 
        {url: `https://do1pg20gb8r9m.cloudfront.net/Interests/interest_3_.jpg`, name: 'Music'},
        {url: `https://do1pg20gb8r9m.cloudfront.net/Interests/interest_4_.jpg`, name: 'Drawing'}, 
        {url: `https://do1pg20gb8r9m.cloudfront.net/Interests/interest_5_.jpg`, name: 'Painting'}, 
        {url: `https://do1pg20gb8r9m.cloudfront.net/Interests/interest_6_.jpg`, name: 'Sculpting'},
        {url: `https://do1pg20gb8r9m.cloudfront.net/Interests/interest_7_.jpg`, name: 'Photography'}, 

    ]




    return(
        <div>

         <Box mt="120px" >
            <div class="slider">
                <div class="slide-track">

                        {
                            images.map((image) => (
                                <div>
                                    <div class="slide">
                                        <Image src={image.url} borderRadius="100px" h="200px" w="200px" objectFit="cover" />
                                        <Text fontWeight={900} textAlign="center" marginTop="10px">{image.name}</Text>
                                    </div>
                                
                                </div>
                            ))
                        }
        
                </div>
            </div>

            </Box>
  
        </div>
    )
}

function Area4(){
    return(
        <div>
            <Box mt="120px" >
    
                <Text fontSize={["2rem", "2rem", "2rem", "3.125rem"]} mt="20px" fontWeight="800" w="60%">
                    What are Hangouts?
                </Text>
                <Text  fontWeight="800" mt="20px" w={["100%", "100%", "100%", "70%"]} >
                Hangouts are in-person and online activities and classes hosted by local experts. Learn new skills, meet new people and build social connection.
                </Text>


            </Box>
        </div>
    )
}


function Area5(){
    return(
        <div>
            <Box mt="50px" >
    
                <Grid templateColumns={["repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(3, 1fr)"]} gap={10} my={5}>

                <Box w="100%" mt="50px">
                        <Text textAlign="center"  fontSize="2rem" fontWeight="800" color="#4f8df7" >
                            1
                        </Text>
                        <Text textAlign="center"  fontSize="1.5rem" fontWeight="800">
                            Create a free account
                        </Text>
                        <Text textAlign="center"  mt="10px" >
                            Join others in sharing experinces, making meaningful connections and a sense of community.
                        </Text>
                    </Box>
                    <Box w="100%" mt="50px" >
                        <Text textAlign="center"  fontSize="2rem" fontWeight="800" color="#4f8df7" >
                            2
                        </Text>
                        <Text textAlign="center"  fontSize="1.5rem" fontWeight="800">
                            Join a Hangout
                        </Text>
                        <Text textAlign="center"  mt="10px" >
                            Learning something new from experts in your community. When you are ready, start hosting your own hangouts and make money.
                        </Text>
                    </Box>
                    <Box w="100%" mt="50px" >
                        <Text textAlign="center"  fontSize="2rem" fontWeight="800" color="#4f8df7" >
                            3
                        </Text>
                        <Text textAlign="center"  fontSize="1.5rem" fontWeight="800">
                            Build social connection
                        </Text>
                        <Text textAlign="center"  mt="10px" >
                            After the hangout is wrapped up, get to know people and invite them to more hangouts.
                        </Text>
                    </Box>
                </Grid>

            </Box>
        </div>
    )
}




export default function Hangouts(){
    return(
        <div>
        
            <Image 
            w="full"
            h="500px"
            objectFit="cover"
            src="https://do1pg20gb8r9m.cloudfront.net/hangoutsMain-min.jpg" />

            <Container maxW={["90%", "90%", "90%", "80%"]} mb={10} py={8} p={[0, 0, 0, 4]}>
                <Area1/>
                <Area2/>
            </Container>
            <Area3/>

            <Container maxW={["90%", "90%", "90%", "80%"]} mb={10} py={8} p={[0, 0, 0, 4]}>
                <Area4/>
            </Container>

            <Image 
            w="full"
            h="500px"
            objectFit="cover"
            src="https://images.pexels.com/photos/1365425/pexels-photo-1365425.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260" />

            <Container maxW={["90%", "90%", "90%", "80%"]} mb={10} py={8} p={[0, 0, 0, 4]}>
                <Area5/>
            </Container>

            <br/>
            <br/>




        </div>

    )
}